export async function fetchAlbums() {
  const urls = ["/data/albums.json", "/data/albums.extra.json"]; // extra is optional
  const lists = await Promise.all(
    urls.map((u) =>
      fetch(u)
        .then((r) => (r.ok ? r.json() : []))
        .catch(() => [])
    )
  );
  const out = lists.flat().filter(Boolean);
  // Sort ascending by year
  out.sort((a, b) => (a.year || 0) - (b.year || 0));
  return out;
}
